const usingBase = Boolean(process.env.REACT_APP_API_BASE_URL);
const fallbackV4 = !usingBase && process.env.REACT_APP_API_V4;

if (fallbackV4) {
  // Single-run deprecation warning (module scope). Intentionally concise to avoid log spam.
  // Removal plan: once all environments define REACT_APP_API_BASE_URL, delete REACT_APP_API_V4 support.
  // Track: ODIN-TRAINING deprecate REACT_APP_API_V4.
  console.warn(
    '[deprecation] REACT_APP_API_V4 is deprecated; define REACT_APP_API_BASE_URL (ending with /) instead. Support will be removed after migration.'
  );
}

const rawBaseURL = usingBase ? `${process.env.REACT_APP_API_BASE_URL}v4/` : process.env.REACT_APP_API_V4;
const rawApiKey = process.env.REACT_APP_API_KEY;

if (!rawBaseURL) {
  throw new Error('Missing REACT_APP_API_BASE_URL');
}

if (!rawApiKey) {
  throw new Error('Missing REACT_APP_API_KEY');
}

export const apiBaseUrl: string = rawBaseURL;
export const apiKey: string = rawApiKey;
